import type { SeoResolver } from '../types';
import { getBrandLabel } from '../../constants/fuel';

/** SEO for a selected fuel station outlet. */
export const fuelSeoResolver: SeoResolver = (ctx) => {
  const fuel = ctx.selections.fuelStation;
  if (!fuel) return null;

  const { siteName, pageUrl } = ctx;
  const p = fuel.properties;
  const brandLabel = getBrandLabel(p.brand);
  const stationName = p.name || brandLabel;
  const district = p.district || '';
  const pincode = p.pincode ? `PIN ${p.pincode}` : '';
  const cityOrDistrict = p.city || district;

  const title = `${stationName} Petrol Bunk in ${cityOrDistrict} | ${siteName}`;
  const description = `Find address, available fuels (${(p.fuelGroups || []).join(', ')}), forecourt amenities, and exact coordinates for ${stationName} (${brandLabel}) in ${district}${pincode ? `, ${pincode}` : ''}.`;
  const breadcrumbLabel = stationName;

  const schema: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'GasStation',
    name: stationName,
    description,
    url: pageUrl,
    brand: {
      '@type': 'Brand',
      name: brandLabel
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: p.address || '',
      addressLocality: p.city || district,
      addressRegion: 'Tamil Nadu',
      postalCode: p.pincode && p.pincode !== 'UNKNOWN' ? String(p.pincode) : undefined,
      addressCountry: 'IN'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: p.lat,
      longitude: p.lng
    }
  };

  if (p.contact) {
    schema.telephone = p.contact;
  }

  return {
    title,
    description,
    breadcrumbLabel,
    schema
  };
};
